import React from "react";
import SearchIcon from "@material-ui/icons/Search";
import { OutlinedInput, InputAdornment, IconButton } from "@material-ui/core";

const SearchBar = (props) => {
  const { inputRef, onSearch } = props;

  return (
    <div>
      <OutlinedInput
        id="search-bar-input"
        inputProps={{
          style: {
            textTransform: "uppercase",
            width: "680px",
            height: "24px",
          },
        }}
        inputRef={inputRef}
        onKeyPress={(event) => {
          if (event.key === "Enter") onSearch(event);
        }}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              id="search-bar-icon"
              disableRipple={true}
              onClick={onSearch}
            >
              <SearchIcon className={"search-icon"} />
            </IconButton>
          </InputAdornment>
        }
      />
    </div>
  );
};

export default SearchBar;
